import { usePageContext } from '@pages/User/NewJobPage/providers/PageProvider';
import { useAuthContext } from '@providers/AuthProvider';
import { JobsService } from 'app/API';
import { notifyApiCallError } from 'app/http/notifyApiCallError';
import toast from 'react-hot-toast';
import { useEditJobMutation } from './useEditJobMutation';

const SAVE_FAILED_MESSAGE = 'Something went wrong. Please check your internet connection and try again';

type TJobStatus = Parameters<typeof JobsService.editJob>[0]['requestBody']['status'];

export const useSaveJob = (saveFilesOrder: () => void) => {
  const { workspace } = useAuthContext();
  const { form, job, ensureDraftJob, setIsSaving } = usePageContext();
  const editJobMutation = useEditJobMutation();

  const persistJob = async (workspaceId: string, status: TJobStatus) => {
    try {
      saveFilesOrder();
      const ensuredJobId = job?.id ?? (await ensureDraftJob());
      if (!ensuredJobId) {
        toast.error(SAVE_FAILED_MESSAGE);
        return null;
      }
      const result = await editJobMutation.mutateAsync({
        jobId: ensuredJobId,
        wsid: workspaceId,
        requestBody: { ...form.item, status },
      });
      if (!result?.id) {
        toast.error(SAVE_FAILED_MESSAGE);
        return null;
      }
      return result;
    } catch (error) {
      notifyApiCallError(error);
      return null;
    }
  };

  return async (status: TJobStatus) => {
    if (!workspace || !form.item?.id) {
      return null;
    }
    setIsSaving(true);
    const result = await persistJob(workspace.id, status);
    if (!result) {
      setIsSaving(false);
    }
    return result;
  };
};
